module.exports = __webpack_public_path__ + "static/media/apple.43a7e033.jpg";